import { render, staticRenderFns } from "./relayStats.vue?vue&type=template&id=7821f669&"
import script from "./relayStats.vue?vue&type=script&lang=ts&"
export * from "./relayStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports